import { ColumnConfig, PrincipalTeamInvitesColumnKey } from '../../model';

export const principalTeamInvitesConfig: Record<
  PrincipalTeamInvitesColumnKey,
  ColumnConfig
> = {
  user: {
    name: 'User',
    field: 'component',
  },
  role: {
    name: 'Role',
  },
  divisionsCFALocation: {
    name: 'CFA Location',
    field: 'component',
  },
  status: {
    name: 'Invite Status',
  },
  customer: {
    name: 'Customers/CFA',
    field: 'addAction',
    alignment: 'flex-end',
  },
  actions: { name: 'Actions', alignment: 'flex-end' },
};
